var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.60781,8L5.72893,4.28169C5.4236899,3.989572,5.4236899,3.511749,5.72893,3.219627C6.033421,2.9267909,6.53216,2.9267909,6.8374,3.219627L11.26601,7.46432C11.26751,7.46575,11.26976,7.46647,11.27126,7.4679C11.42425,7.61431,11.5,7.80716,11.5,8C11.5,8.19284,11.42425,8.38569,11.27126,8.5321C11.26976,8.53425,11.26751,8.53425,11.26601,8.53568L6.8374,12.78037C6.53216,13.0732,6.033421,13.0732,5.72893,12.78037C5.4236899,12.48825,5.4236899,12.01043,5.72893,11.71831L9.60781,8Z",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.71a74f98f078befc75e2a3d9ad6f5d1b.svg";
export { ForwardRef as ReactComponent };